import React, { useState, useEffect } from "react";
import "./notification-container.css";
import NotificationItem from "../notification-item/NotificationItem";
import { LiaThumbtackSolid } from "react-icons/lia";
import Button from "../../../../ui/atoms/buttons/Button";
import InputText from "../../../../ui/atoms/inputs/input-text/InputText";
import InputSelect from "../../../../ui/atoms/inputs/input-select/InputSelect";
import CustomizedTextEditor from "../../../../ui/organisms/customized-text-editor/CustomizedTextEditor";
import MessageBox from "../../../../ui/atoms/message-box/MessageBox";
import Loading from "../../../../ui/atoms/loading/Loading";
import NotFound from "../../../../ui/organisms/not-found/404";
//
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { onGetSchools, onGetStreams } from "../../../admin/services/school";
import {
  onCreateNotification,
  onGetNotifications,
  onGetNotificationsReleased,
} from "../../../admin/services/user";
import { capitalizeAll, isEmpty, wait } from "../../../../core/utils/helpers";
import Swal from "sweetalert2";
import moment from "moment";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const NotificationContainer = () => {
  const { t } = useTranslation();
  const axiosPrivate = useAxiosPrivate();

  const [isNewNotification, setIsNewNotification] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isShowingMsgBox, setIsShowingMsgBox] = useState(false);
  const [messageData, setMessageData] = useState({ type: "", text: "" });

  const [notificationsData, setNotificationsData] = useState([]);
  const [currentNotification, setCurrentNotification] = useState({});
  const [isRefresh, setIsRefresh] = useState(false);

  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");

  const [selectedProgramLanguage, setSelectedProgramLanguage] = useState("");
  const [schoolsData, setSchoolsData] = useState([]);
  const [streamsData, setStreamsData] = useState([]);

  const [selectedSchool, setSelectedSchool] = useState("");
  const [selectedStream, setSelectedStream] = useState("");

  const [schoolsArray, setSchoolsArray] = useState([]);
  const [streamsArray, setStreamsArray] = useState([]);

  const initConnectedUser = useSelector(
    (state) => state.setInitConf.initConnectedUser,
  );

  const _sys_role = initConnectedUser?.sys_role;
  const _inscription = initConnectedUser?.inscription;

  const currentConnectedStream = useSelector(
    (state) => state.setInitConf.currentConnectedStream,
  );

  const _inscription_id = currentConnectedStream?.inscription_id;
  
  useEffect(() => {
    const fetchData = async () => {
      let isMounted = true;
      const controller = new AbortController();
      const signal = controller.signal;

      const _inscript =
        _sys_role === "student" ? _inscription_id : _inscription;

      const _data = {
        inscription_id: _inscript,
        sys_role: _sys_role,
      };

      await onGetNotifications(axiosPrivate, _data, signal).then((response) => {
        const _data = response?.data?.result || [];
        setNotificationsData(_data);
      });

      return () => {
        isMounted = false;
        isMounted && controller.abort();
      };
    };
    fetchData();
  }, [isRefresh]);

  useEffect(() => {
    const fetchData = async () => {
      let isMounted = true;
      const controller = new AbortController();
      const signal = controller.signal;

      await onGetSchools(axiosPrivate, signal).then((response) => {
        const _data = response?.data?.result || [];
        setSchoolsData(_data);
      });

      await onGetStreams(axiosPrivate, signal).then((response) => {
        const _data = response?.data?.result || [];
        setStreamsData(_data);
      });

      return () => {
        isMounted = false;
        isMounted && controller.abort();
      };
    };
    if (isNewNotification) {
      fetchData();
    }
  }, [isNewNotification]);

  useEffect(() => {
    const onLoading = async () => {
      Swal.fire({
        title: "Loading Schools...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      //
      await wait(1000);
      //
      const tmpArray = schoolsData?.filter(
        (el) =>
          el?.school_is_activated &&
          el?.school_is_deleted === false &&
          el?.school_language === selectedProgramLanguage,
      );

      const _avalaibleSchools = Array.from(tmpArray, (item, _) => ({
        key: item?.school_id,
        title: capitalizeAll(item?.school_title),
        is_activated: false,
      }));

      setSchoolsArray(_avalaibleSchools);
      Swal.close();
    };
    if (isNewNotification) {
      onLoading();
    }
  }, [selectedProgramLanguage]);

  useEffect(() => {
    const onLoading = async () => {
      setSelectedStream("");
      Swal.fire({
        title: "Loading Streams...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      //
      await wait(1000);
      //
      const tmpArray = streamsData?.filter(
        (item) =>
          item?.school_id === selectedSchool &&
          item?.classe_is_activated === true &&
          item?.classe_is_deleted === false,
      );

      const _avalaibleStreams = Array.from(tmpArray, (item, _) => ({
        key: item?.classe_id,
        title: capitalizeAll(item?.classe_title),
        is_activated: false,
      }));
      setStreamsArray(_avalaibleStreams);
      Swal.close();
    };
    if (isNewNotification) {
      onLoading();
    }
  }, [selectedSchool]);

  const onSubmit = async () => {
    if (isEmpty(selectedStream)) {
      Swal.fire({
        title: "Notification Creation",
        text: "You should selected a Stream's target",
        icon: "warning",
      });
      return;
    }
    if (isEmpty(subject)) {
      Swal.fire({
        title: "Notification Creation",
        text: "You should provide the subject",
        icon: "warning",
      });
      return;
    }
    if (isEmpty(description)) {
      Swal.fire({
        title: "Notification Creation",
        text: "You should provide the notification's content",
        icon: "warning",
      });
      return;
    }
    setIsSending(true);
    await wait(1000);
    //
    const _data = {
      inscription_id: _inscription,
      selectedStream: selectedStream,
      subject: subject,
      description: description,
      dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };

    onCreateNotification(axiosPrivate, _data)
      .then((response) => {
        setIsSending(false);
        const _data = response?.data;

        if (_data?.status) {
          setIsShowingMsgBox(true);
          setMessageData({ type: "success", text: _data?.message });
          setSelectedStream("");
          setSubject("");
          setDescription("");

          setIsRefresh((prevState) => !prevState);

          const timer = setTimeout(() => {
            setIsShowingMsgBox(false);
            setMessageData({ type: "", text: "" });
          }, 2000);
          return () => clearTimeout(timer);
        } else {
          setIsShowingMsgBox(true);
          setMessageData({ type: "warning", text: _data?.message });
          //
          const timer = setTimeout(() => {
            setIsShowingMsgBox(false);
            setMessageData({ type: "", text: "" });
          }, 4000);
          return () => clearTimeout(timer);
        }
      })
      .catch((error) => {
        setIsSending(false);
        setIsShowingMsgBox(true);
        if (!error?.response) {
          setMessageData({ type: "info", text: "No server response" });
        } else {
          setMessageData({
            type: "warning",
            text: error?.response?.data?.detail?.message,
          });
        }
        const timer = setTimeout(() => {
          setIsShowingMsgBox(false);
          setMessageData({ type: "", text: "" });
        }, 2000);
        return () => clearTimeout(timer);
      });
  };

  const onReleased = async () => {
    Swal.fire({
      title: "Do you really want to released te message ?",
      text: "This action will make the message visible and accessible to all of target!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Release",
    }).then((result) => {
      if (result.isConfirmed) {
        // Perform delete action
        //
        Swal.fire({
          title: "Processing...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        // Simulate async operation (e.g., API call)
        const _data = {
          notification_id: currentNotification?.id,
          status: "sent",
          dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        };
        onGetNotificationsReleased(axiosPrivate, _data)
          .then((response) => {
            if (response?.data?.status) {
              Swal.close();
              //
              setIsRefresh((prevState) => !prevState);
              //
              Swal.fire(
                "Releasing Message...",
                "The message has been Released",
                "success",
              );
            }
          })
          .catch((error) => {
            Swal.close(); // close loading if error
            if (!error?.response) {
              Swal.fire("Error!", "No server response", "error");
            } else {
              Swal.fire(
                "Error!",
                error?.response?.data?.detail?.message,
                "error",
              );
            }
          });
      } else if (
        result.isDismissed ||
        result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire({
          title: "Cancelled",
          text: "The triggered action was cancelled!",
          icon: "error",
        });
      }
    });
  };

  return (
    <React.Fragment>
      <div className="notification-container">
        <div className="notif-cont-options">
          {_sys_role === "admin" && (
            <div className="notif-cont-options-head">
              <Button
                type={"button"}
                preferedStyle={"normal"}
                title={"New notification"}
                action={() => setIsNewNotification(true)}
              />
            </div>
          )}
          <div className="notif-cont-items">
            {isEmpty(notificationsData) ? (
              <p
                style={{
                  fontStyle: "italic",
                  color: "grey",
                  fontSize: "1rem",
                  textAlign: "center",
                }}
              >
                No notification item available yet!
              </p>
            ) : (
              notificationsData?.map((notification) => {
                return (
                  <NotificationItem
                    key={notification?.id}
                    from={notification?.from}
                    date={notification?.sent_at}
                    title={notification?.title}
                    status={_sys_role === "admin" ? notification?.status : null}
                    onAction={() => setCurrentNotification(notification)}
                  />
                );
              })
            )}
          </div>
        </div>
        {isEmpty(notificationsData) ? (
          <NotFound
            type={"data"}
            title={"No Notification found!"}
            text={"No notification available yet."}
            isBoutton={false}
          />
        ) : (
          <div className="notif-cont-box">
            {!isEmpty(currentNotification) && (
              <>
                <div className="notif-cont-box-head">
                  {_sys_role === "admin" &&
                    currentNotification?.status === "pending" && (
                      <div className="w-fit-content pb-xs">
                        <Button
                          type={"button"}
                          preferedStyle={"default"}
                          title={"Click to definetly send the message"}
                          action={() => onReleased()}
                        />
                      </div>
                    )}
                  <h1>{capitalizeAll(currentNotification?.title)}</h1>
                  <div className="notif-cont-box-head-description">
                    <div className="col">
                      <h3>From: {capitalizeAll(currentNotification?.from)}</h3>
                      <p>To: {capitalizeAll(currentNotification?.to)}</p>
                    </div>
                    <div className="info-action">
                      <span className="span-date">
                        {`${moment(currentNotification?.sent_at).format("LLL")} (${moment(currentNotification?.sent_at).fromNow()})`}
                      </span>
                      <span className="span-tick">
                        <LiaThumbtackSolid className="icon" />
                      </span>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="w-full p-xs">
                  <div
                    className="ql-editor"
                    style={{ height: "auto" }}
                    dangerouslySetInnerHTML={{
                      __html: currentNotification?.message,
                    }}
                  />
                </div>
              </>
            )}
          </div>
        )}
      </div>
      {/* Notification's Creation */}
      <div
        className={
          isNewNotification
            ? "notification-stage slide-in"
            : "notification-stage slide-out"
        }
      >
        <div className="notification-stage-container">
          <div className="notification-stage-head">
            <div>
              <h1>Notification Creation</h1>
              <p>
                Create a notification that represente an information in order to
                make the defined target aware.
              </p>
            </div>
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={"Close"}
              action={() => setIsNewNotification(false)}
            />
          </div>
          <div className="notification-stage-body">
            {isShowingMsgBox && (
              <div className="w-full mb-xs">
                <MessageBox type={messageData?.type} msg={messageData?.text} />
              </div>
            )}
            <div className="w-full p-xs">
              <div className="w-full">
                <InputSelect
                  name={"program_language"}
                  placeholder={t("user.program_language")}
                  data={[
                    {
                      key: "en",
                      title: "English",
                      is_activated: false,
                    },
                    {
                      key: "fr",
                      title: "French",
                      is_activated: false,
                    },
                  ]}
                  value={selectedProgramLanguage}
                  onChange={(e) => setSelectedProgramLanguage(e.target.value)}
                />
              </div>
              <div className="w-full d-flex gap-xs mt-md">
                <div className="w-50">
                  <InputSelect
                    name={"school"}
                    placeholder={"School of Interest"}
                    data={schoolsArray}
                    value={selectedSchool}
                    onChange={(e) => setSelectedSchool(e.target.value)}
                  />
                </div>
                <div className="w-50">
                  <InputSelect
                    name={"stream"}
                    placeholder={"Stream (Class) of Interest"}
                    data={streamsArray}
                    value={selectedStream}
                    onChange={(e) => setSelectedStream(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="w-full p-xs">
              <InputText
                type={"text"}
                name="subject"
                title={"Notification Subject"}
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>
            <div className="w-full p-xs">
              <CustomizedTextEditor
                content={description}
                setContent={setDescription}
              />
            </div>
            <div className="w-fit-content m-auto">
              {isSending ? (
                <Loading type={"type-1"} />
              ) : (
                <Button
                  type={"button"}
                  preferedStyle={"normal"}
                  title={"Create Notification"}
                  action={() => onSubmit()}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NotificationContainer;
